var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"preview-card-container"},[_c('h3',{staticStyle:{"margin-left":"10px"}},[_vm._v(" 原始圖卡 ")]),_c('div',{ref:"card_ele",staticClass:"card-container"},[_c('div',{staticClass:"card",style:({
                overflow:'hidden',
                display:'flex',
                flexDirection:'column',
                width:'100%',
                minWidth:'340px',
                boxShadow:'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'						
            })},[_c('Timer',{attrs:{"setting":_vm.timer_setting,"activate":this.oldSettingData !== null ? this.oldSettingData.is_countdown : _vm.marketing_card.is_auto_coupon}}),_c('article',{staticClass:"card-content",style:({
                    display: 'flex',
                    flexDirection: 'row',
                    overflow: 'hidden',
                    maxHeight: '100px'								
                })},[_c('img',{ref:"img",staticClass:"card-img",style:({
                        minWidth: '100px',
                        maxWidth: '100px',
                        width: '100px',
                        height: '100px',
                        minHeight: '100px',
                        maxHeight: '100px',
                        backgroundColor: _vm.marketing_card_setting.card_img_bg_color,	
                    }),attrs:{"src":_vm.marketing_card_setting.img_url !== '' ? _vm.marketing_card_setting.img_url : _vm.card_img_src}}),_c('section',{staticClass:"card-text",style:({
                        width: '100%'		
                    })},[_c('div',{staticClass:"card-header",style:({
                            minHeight: '1em',
                            backgroundColor: _vm.marketing_card_setting.card_title_bg_color,
                            color: _vm.marketing_card_setting.card_title_color,
                            position: 'relative'
                            
                        })},[_c('h3',{style:({
                                textAlign: _vm.marketing_card_setting.card_title_align,
                                paddingLeft: '12px',
                                paddingRight: '15px',
                                paddingTop: '3px',
                                paddingBottom: '3px',
                                fontSize: '20px',
                                margin: '0px',
                                fontWeight: 'bold',
                                lineHeight: 'normal'
                            })},[_vm._v(" "+_vm._s(_vm.marketing_card_setting.card_title)+" ")]),_c('i',{style:({
                                position: 'absolute',
                                color: _vm.marketing_card_setting.card_close_color,
                                fontStyle: 'normal',
                                right: '12px',
                                top: '4px',
                                cursor: 'pointer'
                            }),attrs:{"name":"close_card_btn"}},[_vm._v(" ✕ ")])]),_c('section',{staticClass:"card-text-content",style:({
                            paddingTop: '3px',
                            lineHeight:1.2,
                            paddingLeft: '12px',
                            height:'100%',
                            backgroundColor: _vm.marketing_card_setting.card_content_bg_color,
                            fontSize:'16px',
                        }),domProps:{"innerHTML":_vm._s(_vm.marketing_card_setting.tinymce_content)}})])]),_c('article',{staticClass:"card-footer",style:({
                    minHeight: '1em',
                    backgroundColor: _vm.marketing_card_setting.card_hint_bg_color,
                })},[_c('h3',{style:({
                        textAlign: _vm.marketing_card_setting.card_hint_align,
                        margin: '0px',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        letterSpacing: '3px',
                        whiteSpace: 'no',
                        color: _vm.marketing_card_setting.card_hint_color,
                        padding: '5px',
                        lineHeight: 'normal'
                    })},[_vm._v(" "+_vm._s(_vm.marketing_card_setting.card_hint)+" ")])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }